module.exports = __webpack_public_path__ + "static/img/plane-1@3x.58592db.png";